import { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

export default function Layout({ children }: { children?: ReactNode }) {
  return (
    <div className="main-container container-lg">
      <Header />
      <main>{children || <Outlet />}</main>
      <Footer />
    </div>
  );
}
